import { createApp } from "vue";
import App from "./App.vue";
import { i18n } from "./locales/index";
import AllComponent from "./components";
import vant from "vant";
import "vant/lib/index.css";
import "./scss/main.scss";
import "aos/dist/aos.css";

const app = createApp(App);
AllComponent.register(app);
app.use(vant);
app.use(i18n);
app.mount("#app");
